<template>
  <div id="header">
    <b-container class="bv-example-row">
      <b-row>
        <b-col cols="2" class="emo">    
          <span v-if="forecast">
            <span class="emoji">{{ icons[forecast.currently.icon] }}</span>
          </span>
        </b-col>
        <b-col cols="2" class="info">
          <span v-if="forecast">
            <div class="summary">{{ forecast.currently.summary }}</div>
            <strong>{{ temperature }}℃</strong>
          </span>
        </b-col>
        <b-col cols="4" class="title">
          <h1><router-link to="/" class="brand-logo">To do it!</router-link></h1>        
        </b-col>    
        <b-col cols="4">
          &nbsp; 
        </b-col>  
      </b-row>
    </b-container>
  </div>
</template>

<script>
import API from '@/lib/API';

export default {
  data(){
    return{
      location: '',
      address: '',
      forecast: null,
      icons:{
        'clear-day':'🌞',
        'clear-night': '🌞',
         'rain': '☔',
         'snow': '⛄',
         'sleet': '❄',
         'wind': '🌀',
         'fog': '☁',
         'cloudy': '☁',
         'partly-cloudy-day': '⛅',
         'partly-cloudy-night': '⛅'
      }
    };
  },
  created() {
    navigator.connection.addEventListener('change', this.getNetwork);

    navigator.geolocation.getCurrentPosition(location=>{
      this.loadWeather(location.coords.latitude, location.coords.longitude);
    });

  },
  methods:{
    loadWeather(lat, lng){
      API.getAddress(lat, lng).then(result => {
        this.address = [result.name, result.street].join(' ');
        //localStorage.address = this.address;
      });
      API.getForecast(lat, lng).then(result => {
        this.forecast = result;
      });
    }
  },
  computed:{
    temperature(){
        return Math.round((this.forecast.currently.temperature - 32) / 1.8);
    }
  }
};
</script>

<style scoped>
  #header{
    margin-top: 3%;
    margin-bottom: 3%; 
  }
  .title{
    text-align: center;
    padding-top: 1rem;
  }
  .emo{
    text-align: right;
  }
  .emoji{
    font-size: 3rem;
  }
  .summary{
    padding-bottom: 0; 
  }
  .info{
    text-align: left;
    padding-left: 0; 
    padding-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/TodoHeader.vue